import styled from "styled-components";

import vars from "variables";

import search from "assets/Layout/Dashboard/Sidebar/Wallets/search.svg";
import wallet from "assets/Layout/Dashboard/Sidebar/Wallets/wallet.svg";
import close from "assets/Common/ReactModal/close.svg";

const Root = styled.main`
  ${vars.desktop.mediaQuery} {
    div.connect,
    div.connected,
    div.search {
      width: 200px;
      padding: 24px 22px;
      display: inline-block;
      font-size: 0.8rem;
      font-weight: 600;
      letter-spacing: 0.5px;
      line-height: 1rem;
      text-transform: uppercase;
      position: relative;
      background: ${vars.colors.blue};
      border-radius: 8px;
    }

    div.connect,
    div.search {
      cursor: pointer;
      text-align: center;
    }

    div.connect span {
      padding-left: 30px;
      background-image: url(${wallet});
      background-repeat: no-repeat;
    }

    div.connected span {
      width: 185px;
      margin-bottom: -4px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    div.search {
      margin-top: 18px;
      background: ${vars.colors.background};
    }

    div.search span {
      padding-left: 30px;
      background-image: url(${search});
      background-repeat: no-repeat;
      background-position: 6px center;
    }

    .close {
      top: calc(50% - 10px);
      right: 16px;
      width: 20px;
      height: 20px;
      margin-left: auto;
      cursor: pointer;
      display: inline-block;
      position: absolute;
      background: url(${close}) no-repeat;
      background-size: cover;
    }
  }

  ${vars.mobile.mediaQuery} {
    div.connect,
    div.search {
      margin-top: 4px;
      margin-bottom: -4px;
      margin-left: 15px;
      width: 20px;
      height: 20px;
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 20px;
    }

    div.connect {
      background-color: ${vars.colors.blue};
      mask-image: url(${wallet});
    }

    div.search {
      background-image: url(${search});
    }

    div.connect span,
    div.connected span,
    div.search span {
      font-size: 0;
      position: fixed;
    }
  }
`;

const Message = styled.div`
  &.error {
    text-align: center;
  }

  li {
    display: flex;
    cursor: pointer;
    align-items: center;
    background: rgb(25, 26, 50);
  }

  li.hr {
    height: 1px;
    padding: 0;
    cursor: default;
    display: block;
    line-height: 1px;
    text-align: center;
    background: rgb(51, 53, 80);
  }

  li.hr:hover {
    cursor: default;
    background: rgb(51, 53, 80);
  }

  li.hr span {
    padding: 0 12px;
    display: inline-block;
    background: rgb(33, 35, 65);
  }

  li:hover {
    background: rgb(18, 19, 37);
  }

  li:hover img {
    background: rgb(12, 14, 36);
  }

  strong {
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  img {
    margin-left: auto;
    background: ${vars.colors.marineBlue};
    border-radius: 7px;
  }

  &.search-modal form {
    position: relative;
  }

  &.search-modal input {
    color: white;
    display: block;
    font-family: Jost;
    text-align: center;
    background: #191a32;
    border: 0;
    border-radius: 6px;
  }

  &.search-modal button {
    top: 6px;
    right: 6px;
    position: absolute;
    background: ${vars.colors.grey} url(${search}) center center;
    background-repeat: no-repeat;
    border: 0;
  }

  &.search-modal form.valid button {
    cursor: pointer;
    background-color: ${vars.colors.blue};
  }

  ${vars.desktop.mediaQuery} {
    &.error {
      width: 600px;
    }

    &.error h2 {
      padding: 10px 0 30px;
      font-size: 3.6rem;
    }

    &.error .button {
      margin-bottom: -20px;
    }

    li {
      width: 650px;
      margin: 12px 0;
      padding: 12px;
      border-radius: 7px;
    }

    li.hr {
      width: 662px;
      margin: 40px 6px;
    }

    li.hr span {
      font-size: 1.15rem;
    }

    strong {
      margin-left: 20px;
      font-size: 1.4rem;
    }

    img {
      width: 60px;
      max-height: 60px;
      padding: 12px;
    }

    &.search-modal {
      width: 500px;
    }

    &.search-modal h3 {
      font-size: 1.5rem;
    }

    &.search-modal input {
      width: calc(100% - 115px);
      padding: 18px 85px 22px 30px;
      font-size: 1rem;
    }

    &.search-modal button {
      width: 50px;
      height: 50px;
      background-size: 20px;
      border-radius: 6px;
    }
  }

  ${vars.mobile.mediaQuery} {
    &.error {
      width: calc(100vw - 70px);
    }

    &.error h2 {
      padding: 10px 0 30px;
      font-size: 1.9rem;
    }

    &.error .button {
      margin-bottom: 30px;
    }

    li {
      margin: 9px 0;
      padding: 6px;
      border-radius: 5px;
    }

    li.hr {
      width: calc(100% - 12px);
      margin: 30px 6px;
    }

    li.hr span {
      font-size: 0.8rem;
    }

    strong {
      margin-left: 10px;
      font-size: 0.85rem;
    }

    img {
      width: 25px;
      max-height: 25px;
      padding: 5px;
    }

    &.search-modal form {
      padding-bottom: 20px;
    }

    &.search-modal h3 {
      margin-top: -8px;
    }

    &.search-modal input {
      width: calc(100% - 130px);
      margin-top: 15px;
      margin-left: 10px;
      padding: 13px 85px 17px 30px;
      font-size: 0.9rem;
    }

    &.search-modal button {
      width: 39px;
      height: 39px;
      margin-right: 4px;
      background-size: 20px;
      background-position: 10px center;
      border-radius: 5px;
    }
  }
`;

export { Root, Message };
